import {addJQEventListener} from "@/common/addJQEventListener";

function isPrototypeJsFrameworkEventObserveAvailable () {
    return window.Event && window.Event.observe;
}

function isPrototypeJsFrameworkEventFireAvailable () {
    return window.Event && window.Event.fire;
}

/**
 * In due to the problem, that PrototypeJs Event.observe and jQuery.trigger
 * does not work together, we need this encapsulation for event handling,
 * to ensure that all external
 * @type {{trigger: Event.trigger, on: Event.on}}
 */
export const Event = {

    /**
     * triggers an event
     * if the PrototypeJs framework is available,
     * document.fire is used to ensure that all external
     * event listeners receives the event.
     *
     *
     * @param {Object} element
     * @param {String} eventId
     * @param {Object} (data)
     */
    trigger: function( element, eventId, data ) {

        // check for prototypeJs framework
        if( isPrototypeJsFrameworkEventFireAvailable() ){
            window.Event.fire( element, eventId, data );
            return;
        }

        const event = new CustomEvent( eventId, {detail: data} );
        element.dispatchEvent(event);
    },

    /**
     *
     *
     * @param {Object} element
     * @param {String} eventId
     * @param {Function} callback
      */
    on: function( element, eventId, callback ) {

        // check for prototypeJs framework
        if( isPrototypeJsFrameworkEventObserveAvailable() ) {
            window.Event.observe(element, eventId, ( event ) => {
                callback( event, event.memo );
            });
            return;
        }

        addJQEventListener(element, eventId, callback);
    }
};
